import Vue from 'vue'
import axios from 'axios';
import $ from 'jquery'
import Router from 'vue-router'
// import { component } from 'vue/types/umd'
const Index = () => import('@/page/Index')
const Login = () => import('@/page/Login')
const Survey = () => import('@/page/Survey')
const Template = () => import('@/page/Template')
const Questionnsquare = () => import('@/page/Questionnsquare')
const My = () => import('@/page/My')
const WjManage = () => import('@/page/WjManage')
const WjEdit1 = () => import('@/page/WjEdit1')
const WjEdit = () => import('@/page/WjEdit')
const WjPub = () => import('@/page/WjPub')
const WjStat = () => import('@/page/WjStat')
const Add = () => import('@/page/Add')
const About = () => import('@/page/About')
const Personal = () => import('@/page/Personal')
const Import = () => import('@/page/Import')
// const QuestionType = () => import('@/page/Questionstype')
const QuestionType = () => import('@/page/myQuestionnaire/Questionstype')
const Preview = () => import('@/page/myQuestionnaire/Preview')
const QuestionBank = () => import('@/page/Questionsbank')
const QuestionSetting = () => import('@/page/Questionsetting.vue')
const Logic = () => import('@/page/Logic')
const Appearance = () => import('@/page/myQuestionnaire/Appearance')
const Contant = () => import('@/page/Contant')
const ItemStatistics = () => import('@/page/ItemStatistics')
const itemStatisticsCopy = () => import('@/page/itemStatisticsCopy')
const dataAnalysis = () => import('@/page/dataAnalysis')
const tempanalyse = () => import('@/page/ItemStatistics')
const CrossAnalysis = () => import('@/page/CrossAnalysis')
const DataReport = () => import('@/page/DataReport')
const SourceAnalysis = () => import('@/page/SourceAnalysis')
const Quota = () => import('@/page/Quota')
const Empty = () => import('@/page/Empty')
const SampleManagement = () => import('@/page/SampleManagement')
const PaperDetails = () => import('@/page/PaperDetails')
const SampleAssignment = () => import('@/page/SampleAssignment')
const SampleImport = () => import('@/page/SampleImport')

const AssignInterviewUser = () => import('@/page/AssignInterviewUser')

const Setting = () => import('@/page/Setting')
const WxLogin = () => import('@/page/WxLogin')
const BindUser = () => import('@/page/BindUser')
const Details = () => import('@/page/Details')
const MyProject = () => import('@/page/MyProject')
const Mywallet = () => import('@/page/Mywallet')
// const WxRedPacket= ()=>import('@/page/WxRedPacket')
const TransactionRecord = () => import('@/page/TransactionRecord')
const transaction = () => import('@/page/transaction')
const failing = () => import('@/page/failing')

const messageRecharge = () => import('@/page/messageRecharge')
const emailRecharge = () => import('@/page/emailRecharge')

const MyExam = () => import('@/page/myExam/index')
const ExamManageTop = () => import('@/page/myExam/examManageTop')
const ExamManageLeft = () => import('@/page/myExam/examManageLeft')
const CreateExam = () => import('@/page/myExam/createExam')
const ExamSetting = () => import('@/page/myExam/examSetting')
const ExamAppearance = () => import('@/page/myExam/appearance')

const ExamStats = () => import('@/page/myExam/examStats')
const ResultStats = () => import('@/page/myExam/resultStats')
const RankingList = () => import('@/page/myExam/rankingList')
const RankingListTM = () => import('@/page/myExam/rankingListTM')

const SendTest = () => import('@/page/myExam/sendTest')
const ExamImportQuestion = () => import('@/page/myExam/examImportQuestion')
const ExamPreview = () => import('@/page/myExam/examPreview')
const UserExamPreview = () => import('@/page/myExam/userExamPreview')
const ExamScore = () => import('@/page/myExam/examScore')
const TopicAccuracy = () => import('@/page/myExam/topicAccuracy')
const AnswerSource = () => import('@/page/myExam/answerSource')

// 后台管理系统
const managementIndex = () => import('@/page/managementIndex')
// 用户管理
const managementUser =()=> import('@/page/managementUser')
// 系统设置
const systemSettings =()=> import('@/page/systemSettings/index.vue')
// 筛选
const filtrate =()=> import('@/page/filtrate')
// 电访
const telecommunications =()=> import('@/page/telecommunications/index.vue')
const interviewer =()=> import('@/page/telecommunications/interviewer.vue')
const sample =()=> import('@/page/telecommunications/sample.vue')
const onHook =()=> import('@/page/telecommunications/onHook.vue')
const setSample =()=> import('@/page/telecommunications/setList/setSample.vue')
const addQuota =()=> import('@/page/phoneInterview/addQuota.vue')
const setOverallStatus =()=> import('@/page/telecommunications/setOverallStatus.vue')
const newSampleAssignment =()=> import('@/page/telecommunications/sampleAssignment/index.vue')
const sampleRecycle =()=> import('@/page/telecommunications/sampleRecycle/index.vue')
const sampleMakeOver =()=> import('@/page/telecommunications/sampleMakeOver/index.vue')
const dialConfiguration =()=> import('@/page/telecommunications/dialConfiguration/index.vue')
const SampleReview = () => import('@/page/sampleReview')
const AuditReport = () => import('@/page/auditReport')
const realTimeStatistics =()=> import('@/page/telecommunications/realTimeStatistics/index.vue')
const performanceStatistics =()=> import('@/page/telecommunications/performanceStatistics/index.vue')
//面访
const discussPersonally =()=> import('@/page/discussPersonally/index.vue')
const mfdisplayField =()=> import('@/page/discussPersonally/mfdisplayField.vue')
const setMfSample =()=> import('@/page/discussPersonally/setMfSample/index.vue')

// 发布项目
const PublishProject =()=> import('@/page/publishProject/index.vue')
const ShareLink =()=> import('@/page/publishProject/shareLink.vue')
const MessageShare =()=> import('@/page/publishProject/messageShare.vue')
const EmailShare =()=> import('@/page/publishProject/emailShare.vue')



Vue.use(Router)

// 重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

const router = new Router({
	//mode: 'history',
	//base:"/wjgui/",
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [
		{
			path: '/',
			name: 'Index',
			component: Index
		}, {
			path: '/assignInterviewUser',
			name: 'AssignInterviewUser',
			component: AssignInterviewUser
		},
		{
			path: '/empty',
			name: 'Empty',
			component: Empty
		},
		{
			path: '/login',
			name: 'Login',
			component: Login,
		},
		{
			path: '/survey',
			name: 'Survey',
			component: Survey
		},
		{
			path: '/questionnsquare',
			name: 'Questionnsquare',
			component: Questionnsquare
		},
		{
			path: '/caslogin', // 中转页面
			name: 'Caslogin',
			component: () => import('@/page/transferPage/caslogin')
		},
		{
			path: '/wjmanage',
			name: 'WjManage',
			component: WjManage,
			children: [{
					path: '/wjedit1',
					name: 'WjEdit1',
					component: WjEdit1,
					redirect: '/questionType',
					children: [{
							path: '/questionType',
							name: 'QuestionType',
							component: QuestionType,
						},
						{
							path: '/questionBank',
							name: 'QuestionBank',
							component: QuestionBank,
						},
						{
							path: '/logic',
							name: 'Logic',
							component: Logic,
						},
						{
							path: '/appearance',
							name: 'Appearance',
							component: Appearance,
							mate: {
								title: '在线考试'
							}
						},
						{
							path: '/questionSetting',
							name: 'QuestionSetting',
							component: QuestionSetting,
						},
						{
							path: '/telecommunications',
							name: 'Telecommunications',
							component: telecommunications,
						},
						{
							path: '/discussPersonally',
							name: 'DiscussPersonally',
							component: discussPersonally,
						}
					]
				},
				{
					path: '/wjedit',
					name: 'WjEdit',
					component: WjEdit,
				},
				{
					path: 'wjpub',
					name: 'WjPub',
					redirect: 'wjpub/publishProject',
					component: WjPub,
					children: [{
							path: 'telecommunications',
							name: 'Telecommunications',
							component: telecommunications,
						},
						{
							path: 'discussPersonally',
							name: 'DiscussPersonally',
							component: discussPersonally,
						},{
							path: 'interviewer',
							name: 'Interviewer',
							component: interviewer
						},{
							path: 'setSample',
							name: 'setSample',
							component: setSample
						},
						{
							path: 'sample',
							name: 'sample',
							component: sample
						},
						{
							path: 'onHook',
							name: 'onHook',
							component: onHook
						},
						{
							path: 'addQuota',
							name: 'addQuota',
							component: addQuota
						},
						{
							path: 'newSampleAssignment',
							name: 'newSampleAssignment',
							component: newSampleAssignment
						},{
							path: 'sampleRecycle',
							name: 'sampleRecycle',
							component: sampleRecycle
						},
						{
							path: 'sampleMakeOver',
							name: 'sampleMakeOver',
							component: sampleMakeOver
						},		{
							path: 'sampleReview',
							name: "SampleReview",
							component: SampleReview
						},{
							path: 'realTimeStatistics',
							name: 'realTimeStatistics',
							component: realTimeStatistics
						},{
							path: 'performanceStatistics',
							name: 'performanceStatistics',
							component: performanceStatistics
						},
						{
							path: 'mfdisplayField',
							name: 'mfdisplayField',
							component: mfdisplayField
						},
						{
							path: 'auditReport',
							name: 'AuditReport',
							component: AuditReport
						},
						{
							path: 'publishProject',
							name: 'PublishProject',
							component: PublishProject
						},
						{
							path: 'shareLink',
							name: 'ShareLink',
							component: ShareLink
						},
						{
							path: 'messageShare',
							name: 'MessageShare',
							component: MessageShare,
						},
						{
							path: 'emailShare',
							name: 'EmailShare',
							component: EmailShare,
						},
						{
							path: 'questionSetting',
							name: 'QuestionSetting',
							component: QuestionSetting,
						},
						{
							path: 'setMfSample',
							name: 'setMfSample',
							component: setMfSample
						},
					]
				},
				{
					path: '/wjstat',
					name: 'WjStat',
					component: WjStat,
					redirect: '/itemStatistics',
					children: [{
							path: '/itemStatistics',
							name: 'ItemStatistics',
							component: ItemStatistics
						},
						{
							path: '/crossAnalysis',
							name: 'CrossAnalysis',
							component: CrossAnalysis,
						},
						{
							path: '/dataReport',
							name: 'DataReport',
							component: DataReport
						},
						{
							path: '/sourceAnalysis',
							name: 'SourceAnalysis',
							component: SourceAnalysis
						},
						{
							path: '/itemStatisticsCopy',
							name: 'itemStatisticsCopy',
							component: itemStatisticsCopy
						},
						{
							path: '/dataAnalysis',
							name: 'dataAnalysis',
							component: dataAnalysis
						},
						
					]
				}
			]
		},
		{
			path: '/template',
			name: 'Template',
			component: Template
		},
		{
			path: '/my',
			name: 'My',
			meta: {
				requireAuth: true, // 配置此条，进入页面前判断是否需要登陆
			},
			component: My
		},
		{
			path: '/importQuestion',
			name: 'ImportQuestion',
			meta: {
				requireAuth: true, // 配置此条，进入页面前判断是否需要登陆
			},
			component: () => import('@/page/myQuestionnaire/importQuestion')
		},
		{
			path: '/myExam',
			name: 'MyExam',
			meta: {
				requireAuth: true, // 配置此条，进入页面前判断是否需要登陆
				title: '在线考试',
			},
			component: MyExam,
		},
		{
			path: '/examImportQuestion',
			name: 'ExamImportQuestion',
			meta: {
				requireAuth: true,
				title: '在线考试',
			},
			component: ExamImportQuestion,
		},
		{
			path: '/testQuestionBank',
			name: 'TestQuestionBank',
			meta: {
				requireAuth: true,
				title: '在线考试',
			},
			component: () => import('@/page/myExam/testQuestionBank'),
		},
		{
			path: '/examPreview',
			name: 'ExamPreview',
			meta: {
				requireAuth: true,
				title: '在线考试',
			},
			component: ExamPreview,
		},
		{
			path: '/examQuestionBank',
			name: 'ExamQuestionBank',
			meta: {
				requireAuth: true,
				title: '考试题库',
			},
			redirect: '/examQuestionBankLeft',
			component: () => import('@/page/examQuestionBank/index'),
			children: [
				{
					path: '/examQuestionBankLeft',
					name: 'ExamQuestionBankLeft',
					component: () => import('@/page/examQuestionBank/questionBankLeft'),
					redirect: '/myQuestionBank',
					children: [
						{
							path: '/myQuestionBank',
							name: 'MyQuestionBank',
							component: () => import('@/page/examQuestionBank/questionBank/myQuestionBank'),
						},
						{
							path: '/addQuestionBank',
							name: 'AddQuestionBank',
							component: () => import('@/page/examQuestionBank/questionBank/addQuestionBank'),
						},
						{
							path: '/systemQuestionBank',
							name: 'SystemQuestionBank',
							component: () => import('@/page/examQuestionBank/systemQuestionBank/systemQuestionBank'),
						},
						{
							path: '/testQuestionManagement',
							name: 'TestQuestionManagement',
							component: () => import('@/page/examQuestionBank/testQuestionManagement/testQuestionManagement'),
						},
						{
							path: '/kslabelManagement',
							name: 'kslabelManagement',
							component: () => import('@/page/management/kslabelManagement'),
						},
					]
				},
			]
		},
		{
			path: '/editQuestion',
			name: 'EditQuestion',
			component: () => import('@/page/examQuestionBank/testQuestionManagement/editQuestion'),
		},
		{
			path: '/addTestQuestions',
			name: 'AddTestQuestions',
			component: () => import('@/page/examQuestionBank/questionBank/addTestQuestions'),
		},
		{
			path: '/examManageTop',
			name: 'ExamManageTop',
			meta: {
				requireAuth: true // 配置此条，进入页面前判断是否需要登陆
			},
			component: ExamManageTop,
			meta: {
				title: '在线考试',
			},
			children: [
				{
					path: '/examManageLeft',
					name: 'ExamManageLeft',
					component: ExamManageLeft,
					redirect: '/createExam',
					children: [
						{
							path: '/createExam',
							name: 'CreateExam',
							component: CreateExam,
							meta: {
								title: '在线考试',
							},
						},
						{
							path: '/examAppearance',
							name: 'ExamAppearance',
							component: ExamAppearance,
							meta: {
								title: '在线考试',
							},
						},
						{
							path: '/examSetting',
							name: 'ExamSetting',
							component: ExamSetting,
							meta: {
								title: '在线考试',
							},
						}
					]
				},
				{
					path: '/sendTest',
					name: 'SendTest',
					component: SendTest,
					meta: {
						title: '在线考试',
					},
				},
				{
					path: '/examStats',
					name: 'ExamStats',
					component: ExamStats,
					redirect: '/resultStats',
					children: [
						{
							path: '/resultStats',
							name: 'ResultStats',
							component: ResultStats,
							meta: {
								title: '在线考试'
							}
						},
						{
							path: 'userExamPreview/:id/:userId/:findResultParse/:showGradeBill',
							name: 'UserExamPreview',
							component: UserExamPreview,
							meta: {
								title: '在线考试'
							}
						},
						{
							path: 'rankingList',
							name: 'RankingList',
							component: RankingList,
							meta: {
								title: '在线考试'
							}
						},
						{
							path: '/examScore',
							name: 'ExamScore',
							component: ExamScore,
							meta: {
								title: '在线考试'
							}
						},
						
						
						{
							path: '/topicAccuracy',
							name: 'TopicAccuracy',
							component: TopicAccuracy,
							meta: {
								title: '在线考试'
							}
						},
						{
							path: '/answerSource',
							name: 'AnswerSource',
							component: AnswerSource,
							meta: {
								title: '在线考试'
							}
						},
					]
				},
				
			]
		},
		{
			path: '/userExamPreview/:id/:userId/:findResultParse/:showGradeBill',
			name: 'UserExamPreview',
			component: UserExamPreview,
			meta: {
				title: '在线考试'
			}
		},
		{
			path: '/rankingList',
			name: 'RankingList',
			component: RankingList,
			meta: {
				title: '在线考试'
			}
		},
		{
			path: '/rankingListTM',
			name: 'RankingListTM',
			component: RankingListTM,
			meta: {
				title: '在线考试'
			}
		},
		{
			path: '/preview',
			name: 'Preview',
			component: Preview
		},
		{
			path: '/setting',
			name: 'Setting',
			meta: {
				requireAuth: true // 配置此条，进入页面前判断是否需要登陆
			},
			component: Setting
		},
		{
			path: '/userAnswerPC',
			name: 'UserAnswerPC',
			component: () => import('@/page/myExam/userAnswerPC'),
			meta: {
				title: '在线考试'
			}
		},
		{
			path: '/userAnswer',// 问卷答题页面
			name: 'UserAnswer',
			component: () => import('@/page/myQuestionnaire/userAnswer')
		},
		{
			path: '/add',
			name: 'Add',
			component: Add
		},
		{
			path: '/about',
			name: 'About',
			component: About
		},
		{
			path: '/personal',
			name: 'Personal',
			component: Personal
		},
		{
			path: '/import',
			name: 'Import',
			component: Import
		},
		{
			path: '/contant',
			name: 'Contant',
			component: Contant
		},
		{
			path: '/quota',
			name: 'Quota',
			component: Quota
		},
		{
			path: '/sampleManagement',
			name: 'SampleManagement',
			component: SampleManagement
		},
		{
			path: '/paperDetails',
			name: 'PaperDetails',
			component: PaperDetails
		},
		{
			path: '/sampleAssignment',
			name: 'SampleAssignment',
			component: SampleAssignment
		},
		{
			path: '/sampleImport',
			name: 'SampleImport',
			component: SampleImport
		},
		{
			path: '/wxlogin',
			name: "wxlogin",
			component: WxLogin
		}, {
			path: '/bindUser',
			name: "BindUser",
			component: BindUser
		},
		{
			path: '/details',
			name: "Details",
			component: Details
		},
		
		{
			path: '/MyProject',
			name: "myProject",
			component: MyProject
		},
		{
			path: '/Mywallet',
			name: "mywallet",
			component: Mywallet
		},
		// {
		// 	path:'/WxRedPacket',
		// 	name:'wxRedPacket',
		// 	component:WxRedPacket
		// },
		{
			path: '/TransactionRecord',
			name: 'transactionRecord',
			component: TransactionRecord
		}, {
			path: '/transaction',
			name: 'transaction',
			component: transaction
		}, {
			path: '/failing',
			name: 'failing',
			component: failing
		}, {
			path: '/messageRecharge',
			name: 'messageRecharge',
			component: messageRecharge
		}, {
			path: '/emailRecharge',
			name: 'emailRecharge',
			component: emailRecharge
		},
		{
			path: '/itemStatistics2',
			name: 'itemStatistics2',
			component: tempanalyse
		},
		{
			path: '/managementIndex',
			name: 'managementIndex',
			component: managementIndex,
			children: [
				{
					path: '/addQuestionBankWJ',
					name: 'AddQuestionBankWJ',
					component: () => import('@/page/management/addQuestionBankWJ.vue'),
				},
			]
		},
		{
			path: '/addTestQuestionsWJ',
			name: 'AddTestQuestionsWJ',
			component: () => import('@/page/management/addTestQuestionsWJ'),
		},
		{
			path: '/editQuestionWJ',
			name: 'editQuestionWJ',
			component: () => import('@/page/management/editQuestionWJ'),
		},
		{
			path: '/managementUser',
			name: 'managementUser',
			component: managementUser
		},
		{
			path: '/systemSettings',
			name: 'systemSettings',
			component: systemSettings
		},
		{
			path: '/filtrate',
			name: 'filtrate',
			component: filtrate
		},

		{
			path: '/addQuota',
			name: 'addQuota',
			component: addQuota
		},
		{
			path: '/setOverallStatus',
			name: 'setOverallStatus',
			component: setOverallStatus
		},
		{
			path: '/dialConfiguration',
			name: 'dialConfiguration',
			component: dialConfiguration
		},
		
	]
})
router.beforeEach((to, form, next) => {
	// 处理微信授权回调redirect_uri
	// if (replaceWechatRedirectUri()) return false

	// 第三方跳转到该系统 url携带token,单点登录页面除外'/caslogin'
	if (form.path != '/caslogin') {
		let token = Vue.prototype.$functions.getQueryStringhash('token')
		if (token) {
			localStorage.setItem('token', token)
		}
	}

	//判断跳转的登录页面
	if (window.ssoswitch == "on") {
		if (to.path == "/login") {
			window.location.href = VUE_APP_CAS_BASE_URL + "/login?service=" + VUE_APP_CAS_BACKSERVICE_URL
		} else {
			if (!localStorage.getItem('token')) {
				let ticket = getQueryString("ticket");
				if (ticket != null) {
					caslogin(ticket, to, form, next);
				}
			}
		}
	}
	if (to.matched.some(res => res.meta.requireAuth)) {
		if (localStorage.getItem('token')) {
			if (to.meta.title) { // 判断是否有标题
				document.title = to.meta.title;
			}else {
				document.title = '在线问卷'
			}
			next()
		} else {
			console.log(';;;;;;;;;;;;;;;;;;;;;;;;;;;;;', to.fullPath)
			
			if (to.meta.title) { // 判断是否有标题
				document.title = to.meta.title;
			}else {
				document.title = '在线问卷'
			}
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
		}
	} else {
		
		if (to.meta.title) { // 判断是否有标题
			document.title = to.meta.title;
		}else {
			document.title = '在线问卷'
		}
		next()
	}
})
/**
 * 处理微信授权回调redirect_uri
 */
function replaceWechatRedirectUri() {
	const w = location.href.indexOf('?');
	const j = location.href.indexOf('#');
	// alert(`w:${w}`)
	// alert(`j:${j}`)
	if (w !== -1 && j > w && this.$functions.getQueryStringhash('state')) {
		const state = (this.$functions.getQueryStringhash('state')).split('#')[0];
		const redirect_path = JSON.parse(decodeURIComponent(state)).path;
		const url =
		location.origin +
		'/#' +
		redirect_path +
		`?code=${this.$functions.getQueryStringhash('code')}&id=${JSON.parse(decodeURIComponent(state)).id}`
		alert(url)
		location.replace(url)
		return true
	}
}
async function caslogin(ticket, to, form, next) {
	$.ajax({
		//请求方式
		type: "GET",
		async: false,
		//请求的媒体类型
		contentType: "application/json;charset=UTF-8",
		//请求地址
		url: window.global_host + "/api/v1/sso/caslogin?ticket=" + ticket,
		//数据，json字符串
		//data : JSON.stringify(list),
		//请求成功
		success: function(result) {
			if (result.code == 0) {
				let userInfo = JSON.stringify(result.resultBody);
				window.localStorage.setItem('userInfo', userInfo);
				window.localStorage.setItem('token', result.resultBody.token);
			} else if (result.code == 1001) {
				window.location.href = VUE_APP_CAS_BASE_URL + "/login?service=" +
					VUE_APP_CAS_BACKSERVICE_URL
			}
		},
		//请求失败，包含具体的错误信息
		error: function(e) {
			console.log(error);
		}
	});

	/*await axios({
		method: 'GET',
		url: window.global_host+"/api/v1/sso/caslogin?ticket="+ticket,
	})
		.then(response => {
			if (response.data.code == 0) {
				let userInfo = JSON.stringify(response.data.resultBody);
				window.localStorage.setItem('userInfo', userInfo);
				window.localStorage.setItem('token', response.data.resultBody.token);
			} else if (res.code == 1001) {
				window.location.href = VUE_APP_CAS_BASE_URL + "/login?service=" + VUE_APP_CAS_BACKSERVICE_URL
			}
		})
		.catch(error => {
			console.log(error);
		});*/
}

function getQueryString(name) {
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
	var r = window.location.search.substr(1).match(reg);
	if (r != null) return unescape(r[2]);
	return null;
}
export default router;
